import axios, { POST } from './axiosConfig';

export function getSoftwarePreferences() {
    const timestamp = new Date().getTime()
    return axios({
            method: POST,
            url: `/insightweb/getSoftwarePreferences?q=${timestamp}`,
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            timeout: 5000
        })
        .then(({ data }) => {
            return data
        })
        .catch((error) => {
            console.warn('Failed to get the user preferences ', error)
            throw error
        })
}
